import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import { Page } from '@/components';
import { BigSpinner } from '@/components/BigSpinner';
import { assertNever } from '@/lib/assertions';

import { TermsState, useAcceptTerms } from './useAcceptTerms';

export const TermsPage = () => {
    const { t } = useTranslation();
    const { acceptTerms, fetchTerms, terms, termsState } = useAcceptTerms();

    switch (termsState) {
        case TermsState.INIT:
            fetchTerms();
            return <BigSpinner />;
        case TermsState.LOADING:
        case TermsState.ERROR:
            return <BigSpinner />;
        case TermsState.LOADED:
            return (
                <Page title="">
                    <Container>
                        <Paper elevation={1} sx={{ height: '100%' }}>
                            <Typography
                                variant="h2"
                                component="h2"
                                sx={{
                                    color: 'inherit',
                                    p: 2,
                                    fontSize: '2rem',
                                    textAlign: 'center',
                                }}
                            >
                                {t('page.terms.title', 'Please review the Terms and Conditions')}
                            </Typography>
                            <Box
                                component={Paper}
                                elevation={2}
                                sx={{
                                    m: 4,
                                    p: 2,
                                    maxHeight: 'calc(100% - 250px)',
                                    overflowY: 'auto',
                                }}
                            >
                                <ReactMarkdown>{terms}</ReactMarkdown>
                            </Box>
                            <Stack
                                direction="row"
                                sx={{
                                    justifyContent: 'flex-end',
                                    m: 4,
                                    paddingBottom: 2,
                                }}
                            >
                                <Button variant="contained" onClick={acceptTerms}>
                                    {t('page.terms.accept_button', 'I accept the Terms and Conditions')}
                                </Button>
                            </Stack>
                        </Paper>
                    </Container>
                </Page>
            );
        default:
            assertNever(termsState);
    }
};
